import React, { useRef} from "react";
import { 
	RCCGrid, 
	RCCDropDownItem, 
	RCCIcon,
	RCCAlert,
	RCCCheckBox,
	RCCServicesApi,
	RCCHookToast
} from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import { IRefIndicatorModal } from "src/components/ModalIndicator/interface";
import IndicatorModal from "src/components/ModalIndicator";
import Card from "src/components/Card";
import ListCards from "src/components/ListCards";
import { v4 } from "uuid";
import { css } from "styled-components";
import { standardErrorMessages } from "src/utils/errors";
import CheckPermission from "src/components/CheckPermission";
import { PermissionEnum } from "src/context/Auth/interface";
import { useAuth } from "src/context/Auth/context";
import { usePermissionPath } from "src/context/PermissionPath/context";
import { useHistory } from "react-router-dom";
import { IIndicatorListCard, IIndicatorListGrouper } from "../interface";

const IndicatorListGrouper: React.FC<IIndicatorListGrouper> = ({
	indicatorsList,
	setIndicatorsList,
	hierarchyLevel
}) => {
	const { translate } = useTranslation();
	const { administrator, superUser, checkIfHasSpecificPermission } = useAuth();
	const {addToast} = RCCHookToast();
	const refModal = useRef<IRefIndicatorModal>(null);

	const { permissionPath } = usePermissionPath();
	const history = useHistory();

	const permissionToChange = checkIfHasSpecificPermission(permissionPath ?? history.location.pathname, PermissionEnum.CREATE_UPDATE);

	const handleSelected = (insert:boolean,indicator:IIndicatorListCard) => {
		setIndicatorsList((prevState:Array<IIndicatorListCard>) => prevState.map((item) => {
		
			if(item.iqc001Id === indicator.iqc001Id){
			    const newChildren = item.children || [];
				return {...item,selected:insert,children:newChildren};
			}
			return item;
		
		}));
	};
	const updatecard = async(id:number,updatedIndicator:any) => {
		try {
			if(hierarchyLevel !== updatedIndicator.indicator.iqc001Nivel){
				setIndicatorsList((prevState:Array<IIndicatorListCard>) => prevState.filter((x) => x.iqc001Id !== id));
			}else{
				const dataController = await RCCServicesApi.getRequest({
					method: "Indicators/SimpleSelect",
					urlParameters: {id}
				});
	
				const iqc001 = dataController.data;
				
				setIndicatorsList((prevState:Array<IIndicatorListCard>) => prevState.map((x) => {
					if(x.iqc001Id === iqc001.iqc001Id)
						return {
							...x,
							iqc001Codigo :iqc001.iqc001Codigo,
							iqc001Descricao:iqc001.iqc001Descricao,
							taa001Descricao:iqc001.taa001Descricao,
							taa002Descricao:iqc001.taa002Descricao,
							efa005Nome:iqc001.efa005Nome,
							situation:iqc001.situation
						};
							
					return x;
				}
				));
			}

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar indcador para atualização do card"), addToast);
		}
	};

	const headerRender = (row:any) => (
		<>
			<RCCCheckBox
				name={`seletedIndicator-${v4()}`}
				onChange={(e) => handleSelected(e.target.checked,row)}
				defaultChecked={row.selected}
				label={`${row.iqc001Descricao}(${row.iqc001Codigo})`}
				labelPosition="end"
				disabled={!permissionToChange}
				styleInline={{label:css`
					font-weight: bold;
					font-size: 0.85rem;
					color: var(--default-color-font);
				`}}
			/>
			{(administrator || superUser || row.permission >= 5) && (
				<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
					<OptionsColumn> 
						<RCCDropDownItem
							selfEnclose
							onClick={() => { refModal?.current?.actionButtonChange(row.iqc001Id,false,(updatedIndicator) => updatecard(row.iqc001Id,updatedIndicator)); }}
						>
							<RCCIcon 
								name="pencil" 
							/>
							{translate("Alterar")}
						</RCCDropDownItem>
					</OptionsColumn>
				</CheckPermission>
			)}
		</>
	);
	
	return (
		<>
			{indicatorsList.length>0 ?
				<ListCards 
					data={indicatorsList}
					mapper={(indicator: IIndicatorListCard) => 
						<Card
							key={v4()} 
							title={`${indicator.iqc001Codigo} - ${indicator.iqc001Descricao}`}
							color={indicator.situation === "A" ? "green" : "red"}
							options={<></>}
							hidePercentage
							customHeader={headerRender(indicator)}
							maxCards="2"
						>
							<RCCGrid container spacing={1}>
								<RCCGrid container item>
									{translate("Responsável")}: {indicator.efa005Nome}
								</RCCGrid>
								<RCCGrid container item>
									{translate("Setor")}: {indicator.taa001Descricao}
								</RCCGrid>
								<RCCGrid container item>
									{translate("Classificação")}: {indicator.taa002Descricao}
								</RCCGrid>
							</RCCGrid>
						</Card>
					}
				/>
				:
				<RCCAlert 
					title={translate("Atenção")}
					description={translate("Não foi encontrado indicadores para este nivel")}
					color="blue"
				/>
			}
			<IndicatorModal ref={refModal} /> 
			{/* <DeleteModalIndicator ref={refModalDelete} /> */}
		</>
	);
		
};
export default IndicatorListGrouper;
